import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    var testimonialSliders = document.querySelectorAll('.testimonial-carousel');
    testimonialSliders.forEach(function (container) {
        var carouselSlider = container.querySelector('.testimonial-slider');
        if (!carouselSlider) return;

        var slider = tns({
            container: carouselSlider,
            items: 1,
            slideBy: 1,
            nav: false,
            controls: false,
            autoplay: false,
            speed: 1500,
            loop: true
        });

        var prev = container.querySelector('.slick-prev') || container.querySelector('.left-arrow');
        var next = container.querySelector('.slick-next') || container.querySelector('.right-arrow');
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('prev'); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('next'); });
    });
});


